export default __webpack_public_path__ + "static/media/globe.a860f293.png";